import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=b266b2fe&"
import script from "./Auth.vue?vue&type=script&lang=ts&"
export * from "./Auth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports